import React from 'react';
import {CabanaConfiguration} from "./CabanaConfiguration";

const CabanaConfigurationContext = React.createContext<CabanaConfiguration>({
    auth0: {
        domain: '',
        clientId: '',
        redirectUri: '',
        audience: '',
    },
    graphql: {
        uri: ''
    },
    sentry: {
        dsn: '',
        environment: '',
    },
    stripe: {
        publishableKey: '',
    },
    version: {
        tag: null,
        commit: null,
    },
    languages: {
        supported: ['de', 'en'],
        labels: { de: 'Deutsch', en: 'English' },
    }
});

export default CabanaConfigurationContext;
